import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

const ChatUiVoucherCancellationSchema = z.object({
  // Session challenge issued by the agents ConfirmationService. The confirm
  // button echoes it back via `AppChannelInboundRequest.confirmation` — the
  // structured (non-LLM) approval channel for the destructive cancel. OTP
  // channels never receive this kind.
  challengeId: z.string().min(1),
  intent: z.literal('cancel'),
  expiresInMin: z.number().optional(),
  // Resumo no ponto de não-retorno (handoff). DISPLAY-ONLY — nada aqui autoriza
  // a ação (o guardrail é o challenge verificado server-side). `postEmission`
  // marca que o voucher está EMITIDO: o cancelamento vira uma SOLICITAÇÃO
  // (revisão manual + tag `não utilizado`), espelhando a mensagem da MCP.
  summary: z
    .object({
      voucherCode: z.string(),
      modal: z.string().optional(),
      status: z.string().optional(),
      route: z.string().optional(),
      // Horário já formatado da corrida («Ter, 27 out, 09:00»): o registro da
      // corrida cancelada mostra «Horário» no lugar de «Status» (#6699).
      when: z.string().optional(),
      reason: z.string().optional(),
      postEmission: z.boolean().optional(),
    })
    .optional(),
});
export type ChatUiVoucherCancellation = z.infer<typeof ChatUiVoucherCancellationSchema>;

/** Membro `voucher_cancellation` do `ChatUiSchema` (discriminatedUnion). */
export const VoucherCancellationBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('voucher_cancellation'),
    confirmation: ChatUiVoucherCancellationSchema,
  })
  .strict();
